import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Template from './template';
import { UserApproveReject } from 'components';
import { apiGetUserProfile } from 'api/ZimssaAPI';
import { useApiRequest } from 'hooks';
import { USER_INFO } from 'router/PageUrl';

function UserApproveRejectView(): React.ReactElement {
    const { serviceType, serviceIdx, partnerUserIdx } = useParams<{ serviceType: string, serviceIdx: string, partnerUserIdx: string }>();
    const [fetchResult, fetchProfile] = useApiRequest<any>(apiGetUserProfile);

    useEffect(() => {
        if (serviceIdx && serviceType && partnerUserIdx) {
            fetchProfile({
                type: 'REQUEST',
                body: [partnerUserIdx, serviceType, serviceIdx],
            });
        }
    }, [fetchProfile, partnerUserIdx, serviceIdx, serviceType]);

    useEffect(() => {
        const { result, data } = fetchResult;
        if (result === 'success' && data) {
        }
    }, [fetchResult]);

    const userApproveRejectProps = {
        rjectInfoList: ['프로필이미지 오류'],
        href: `${USER_INFO.url}/${serviceType}/${serviceIdx}/${partnerUserIdx}`,
    };

    return (
        <Template>
            <UserApproveReject {...userApproveRejectProps} />
        </Template>
    );
}

export default UserApproveRejectView;
